export default __webpack_public_path__ + "static/media/digital-camo.6ae01af25c284aaf762d975b34c63a03.svg";